import {
  Box,
  Button,
  Flexbox,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Heading,
  TableData,
  Label,
} from "codekit";
import { useState, useMemo, useEffect } from "react";

const Manifixx = ({ showModal, setShowModal, manifiestos, onSave, onSkip }) => {
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (showModal) {
      setSelectedDocs([]);
      setShowConfirm(false);
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      {
        id: "DTTINUMA",
        title: "Nro. Manifiesto",
        isShow: true,
        isMobileShow: true,
        sorted: false,
        orderBy: null,
        canToggleShow: false,
      },
    ],
    []
  );

  const handleCheckedRows = (checkedRows) => {
    const rows = checkedRows?.rows ?? [];
    if (rows.length > 0) {
      setSelectedDocs([rows[rows.length - 1]]);
    } else {
      setSelectedDocs([]);
    }
  };

  const handleCancelClick = () => {
    if (selectedDocs.length === 0) {
      setShowConfirm(true);
    } else {
      setShowModal(false);
    }
  };

  const handleConfirmSkip = () => {
    setShowConfirm(false);
    setShowModal(false);
    onSkip();
  };

  const activeRowKey = "DTTINUMA";

  return (
    <Modal isOpen={showModal} size="md">
      <ModalHeader>
        <Flexbox justifyContent="between" alignItems="center">
          <Heading variant="heading-6">Asignar Manifiesto</Heading>
          <Button
            variant="secondary"
            icon="close"
            onlyIcon
            onClick={handleCancelClick}
          />
        </Flexbox>
      </ModalHeader>
      <ModalBody>
        {showConfirm ? (
          <Box spacing={4} mt={4} mb={4}>
            <Box bg="warning-100" border={1} borderColor="warning-400" spacing={3} rounded="md">
              <Flexbox gap={2} alignItems="center">
                <Label color="warning-800" icon="triangle-exclamation">
                  <strong>Aviso Informativo</strong>
                </Label>
              </Flexbox>
              <Box mt={2}>
                <Label color="warning-900">
                  El documento de transporte tiene varios manifiestos. Debe seleccionar uno de forma obligatoria, de lo contrario el sistema tomará el que tenga el <strong>mayor valor FOB</strong>. ¿Desea continuar sin seleccionar un manifiesto?
                </Label>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box border={1} borderColor="neutral-300" rounded="md" mt={4}>
            <TableData
              columns={columns}
              data={manifiestos || []}
              isCheckedRow={true}
              handleCheckedRow={handleCheckedRows}
              checkedRows={selectedDocs}
              rowKey={activeRowKey}
              hidePagination
            />
          </Box>
        )}
      </ModalBody>
      <ModalFooter>
        {showConfirm ? (
          <Flexbox justifyContent="between" gap={4}>
            <Button
              variant="secondary-light"
              onClick={() => setShowConfirm(false)}
              minWidth={150}
            >
              Volver
            </Button>
            <Button
              variant="warning"
              onClick={handleConfirmSkip}
              minWidth={150}
            >
              Sí, continuar sin manifiesto
            </Button>
          </Flexbox>
        ) : (
          <Flexbox justifyContent="between" gap={4}>
            <Button
              variant="secondary-light"
              onClick={handleCancelClick}
              minWidth={150}
            >
              Cancelar
            </Button>
            <Button
              variant="primary-bold"
              disabled={selectedDocs.length === 0}
              onClick={() => onSave(selectedDocs[0])}
              minWidth={150}
            >
              Guardar
            </Button>
          </Flexbox>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default Manifixx;
